<div class="form-container">
  <!-- Loading overlay -->
  @if (loading()) {
    <div class="form-loading-overlay">
      <kl-loader [label]="loadingText() || 'loading'" />
    </div>
  }

  <!-- Toolbar -->
  @if (showToolbar()) {
    <div class="form-toolbar">
      @if (!saveHidden() && isEditable()) {
        <p-button
          icon="ph ph-floppy-disk"
          [label]="saveLabel() | translate"
          [text]="true"
          severity="secondary"
          size="small"
          class="form-toolbar__btn"
          [disabled]="saveDisabled()"
          (onClick)="onSave()" />
      }
      @if (!saveHidden() && saveAndNew() && (mode() === 'add' || mode() === 'copy')) {
        <p-button
          icon="ph ph-floppy-disk"
          [label]="'save_and_new' | translate"
          [text]="true"
          severity="secondary"
          size="small"
          class="form-toolbar__btn"
          (onClick)="onSaveAndNew()" />
      }
      @if (mode() === 'view') {
        <p-button
          icon="ph ph-arrow-left"
          [label]="'back' | translate"
          [text]="true"
          severity="secondary"
          size="small"
          class="form-toolbar__btn"
          (onClick)="onBack()" />
      }
      @if (processButtons().length > 0 && (isEditable() || forceShowProcessButtons())) {
        <p-button
          type="button"
          [label]="'processes' | translate"
          icon="ph ph-caret-down"
          iconPos="right"
          [text]="true"
          severity="secondary"
          size="small"
          class="form-toolbar__btn form-toolbar__btn--processes"
          (onClick)="processMenu.toggle($event)" />
        <p-tieredmenu #processMenu [model]="processMenuItems()" [popup]="true" appendTo="body" />
      }
      @for (btn of buttons(); track btn.slug + '-' + (customButtonsDisabled() || isButtonDisabled(btn))) {
        @if (btn.show !== false && mode() !== 'view') {
          <p-button
            [icon]="formButtonIcon(btn.icon)"
            [label]="btn.slug | translate"
            [text]="true"
            severity="secondary"
            size="small"
            class="form-toolbar__btn"
            [disabled]="customButtonsDisabled() || isButtonDisabled(btn)"
            (onClick)="btn.method()" />
        }
      }
      @if (fullScreen() && mode() !== 'view') {
        <p-button
          [icon]="fullscreenIcon()"
          [label]="fullscreenLabelKey() | translate"
          [text]="true"
          severity="secondary"
          size="small"
          class="form-toolbar__btn"
          (onClick)="toggleFullscreen()" />
      }
    </div>
  }

  <!-- Alert (only mount when visible so the host does not reserve margin / vertical space) -->
  @if (alertShow()) {
    <kl-alert
      [show]="true"
      [type]="alertVisualType()"
      [message]="alertMessage()"
      [showClose]="true"
      (onClose)="onCloseAlert()" />
  }

  <!-- Title (optional; hidden in grid dialogs where the modal header is the title) -->
  @if (showTitle() && title()) {
    <div class="form-title">
      <span>{{ title() | translate }}</span>
    </div>
  }

  <!-- Content -->
  <div class="form-content">
    <ng-content />
  </div>
</div>
